<template>
    <div>
        <b-form-group label="Question" label-for="question">
            <TipTap
                v-model="editable_content.question"
                :class="{'is-invalid': validating && !editable_content.question}"
                :menu_items="['bold', 'italic', 'underline', 'bullet_list', 'ordered_list', 'image', 'edit_html']"
            />

            <b-form-invalid-feedback :state="validating && !editable_content.question ? false : null">
                Question is required
            </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label="Answer" label-for="answer">
            <b-form-input type="number" v-model="editable_content.answer" :state="validating && !editable_content.answer ? false : null"/>
            <b-form-invalid-feedback :state="validating && !editable_content.answer ? false : null">
                Answer is required
            </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label="Acceptable Range (+/-)" label-for="range">
            <b-form-input type="number" v-model="editable_content.range" />
        </b-form-group>
    </div>
</template>

<style lang="scss" scoped>

</style>

<script>
import { mapState } from 'vuex'

export default {
    data: () => ({
        editable_content: {question: '', answer: null, range: 0}
    }),
    props: [
        'question'
    ],
    components: {
        TipTap: () => import('@/components/tiptap/TipTap')
    },
    computed: {
        ...mapState({
            validating: state => state.utilities.validating
        })
    },
    watch: {
        question: {
            handler (question) {
                if (question && question.content) {
                    this.editable_content = question.content
                }
            },
            deep: true,
            immediate: true
        },
        editable_content: {
            handler (editable_content) {
                if (editable_content) {
                    this.$set(this.question, 'content', editable_content)
                }
            },
            deep: true
        }
    },
    methods: {

    }
}
</script>
